var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',[_c('router-view',{key:_vm.$route.path}),_c('v-footer',{staticClass:"pa-3 app--footer theme-footer",attrs:{"height":"auto"}},[_c('v-row',{attrs:{"justify":"center","no-gutters":""}},[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_vm._v(" © SAIO "+_vm._s(new Date().getFullYear())+" ")])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }